import {
  LOAD_UPLOADED_FILES,
  LOAD_UPLOADED_DETAILS_SUCCEEDED,
  LOAD_UPLOADED_DETAILS_FAILED,
  LIST_SELECTED,
  START_BULK_VALIDATION,
  DOWNLOAD_REPORT,
  DELETE_BULK_VALIDATION,
  LOAD_SINGLE_EMAILS,
  ADD_INPROCESS,
  DOWNLOAD_SINGLE_REPORT,
  BULK_RE_VALIDATION,
  SWITCH_TAB,
  CLEAR_SINIGLE_EMAILS_DATA,
  HIDE_CONFIRMATION,
  GET_LOGIN_USER_PROFILE_STATUS,
  LOAD_COMPANY_PROFILE_INFO,
  SAVE_USER_COUNTRY,
} from "../../common/constants";

export const loadUploadedFile = (userdata) => {
  // console.log("userdata" + JSON.stringify(userdata));
  return { type: LOAD_UPLOADED_FILES, userdata };
};
export const updateSelectedIndex = (selectedIndex) => {
  // console.log("Selected Index: " + selectedIndex);
  return { type: LIST_SELECTED, selectedIndex };
};
export const startProcess = (fileData) => {
  return { type: ADD_INPROCESS, fileData };
};
export const startValidation = (fileData, selectedIndex, fromPopup) => {
  // console.log("File Data : " + JSON.stringify(fileData));
  return { type: START_BULK_VALIDATION, fileData, selectedIndex, fromPopup };
};
// re verification
export const startReValidation = (fileData, selectedIndex, result) => {
  // console.log("File re-validation Data : " + JSON.stringify(fileData) + result);
  fileData["result"] = result;
  return { type: BULK_RE_VALIDATION, fileData, selectedIndex };
};

export const deleteValidation = (fileData) => {
  // console.log("File Data : " + JSON.stringify(fileData));
  return { type: DELETE_BULK_VALIDATION, fileData };
};
export const downloadReport = (selectedTarget, selectedOption, timeZone) => {
  // console.log("Download Selected Option : " + selectedOption + "Target : " + selectedTarget);
  const selectedData = { selectedTarget, selectedOption, timeZone };
  return { type: DOWNLOAD_REPORT, selectedData };
};
export const downloadSingleEmailsReport = (userDetails) => {
  return { type: DOWNLOAD_SINGLE_REPORT, userDetails };
};
export const loadSigleEmail = (userdata) => {
  // console.log("userdata" + JSON.stringify(userdata));
  return { type: LOAD_SINGLE_EMAILS, userdata };
};

export const clearData = (type) => {
  return {type}
}

export const switchTab = (updateState) => {
  return { type: SWITCH_TAB, updateState };
};

export const hidePopup = () => {
  return {type:HIDE_CONFIRMATION}
}

export const isProfileCompleted = () => {
  return { type: GET_LOGIN_USER_PROFILE_STATUS }
}


export const loadCompanyProfileInfo = () => {
  return {type: LOAD_COMPANY_PROFILE_INFO }
}

export const saveCountryAction = (country) => {
  return {type: SAVE_USER_COUNTRY, country}
}


// WEBPACK FOOTER //
// ./src/Containers/EmailValidation/actions.js